import { type Epic, combineEpics } from 'redux-observable';
import { filter, map, mergeMap, withLatestFrom } from 'rxjs';
import { request } from '@/core';
import { fetchEventOptionsRequest } from '@/api/events';
import {
  tryFetchEventOptions,
  fetchEventOptions,
  setEventOptions,
} from '../actions';
import { hasEventOptions } from '../selectors';

const tryFetchEventOptionsEpic: Epic = (action$, state$) =>
  action$.pipe(
    filter(tryFetchEventOptions.match),
    withLatestFrom(state$),
    map(([, state]) => {
      const hasOptions = hasEventOptions(state);

      if (!hasOptions) {
        return fetchEventOptions();
      }

      return {
        type: 'EVENT_OPTIONS_ALREADY_FETCHED',
      };
    }),
  );

const fetchEventOptionsEpic: Epic = (action$) =>
  action$.pipe(
    filter(fetchEventOptions.match),
    request(fetchEventOptionsRequest, fetchEventOptions),
  );

const fetchEventOptionsSucceededEpic: Epic = (action$) =>
  action$.pipe(
    filter(fetchEventOptions.succeeded.match),
    mergeMap(
      ({
        payload: {
          data: { eventTypes, eventStatuses, sports },
        },
      }) => [
        setEventOptions({
          eventTypes,
          eventStatuses,
          sports,
        }),
      ],
    ),
  );

export default combineEpics(
  tryFetchEventOptionsEpic,
  fetchEventOptionsEpic,
  fetchEventOptionsSucceededEpic,
);
